export const MNG_ITEM_SELECTED = "epadjs/management/MNG_ITEM_SELECTED";
export const CLOSE_MODAL = "epadjs/management/CLOSE_MODAL";
